import withEditAddForm from './withEditAddForm';
import { ConfigContext } from './withConfigAsContext';

// Returns a List of {path, component}
const buildEditAddType = (config) => {
   const { basePath } = config?.settings?.internal?.routing;

   return {
      path: [`${ basePath }/:mode(edit)/:id`, `${ basePath }/:mode(create)`],
      withComponentWrapper: withEditAddForm(config),
      ConfigContext,
   };
};

// Returns a List of {path, component}
// Where path is string URL path where the respective component will be mounted
const build = (config) => {
   return buildEditAddType(config);
};

export default build;
